import {
  Descriptions,
  Table,
  Tag,
  Tooltip,
  Typography,
  Input,
  Button,
  Space,
} from "antd";
import React, { useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";

const RequestLineSelection = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState(props.selectedIds);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
    const selectedItems = props.verifiedLines.filter((item) =>
      selectedRowKeys.includes(item.id)
    );
    props.onSelectChange(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.added,
    }),
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? dataIndex === "runningNo"
          ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
          : record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(
          () =>
            searchInput && searchInput.current && searchInput.current.select(),
          100
        );
      }
    },
    render: (text) => (searchedColumn === dataIndex ? text : text),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumns = () => {
    let columns = [];
    columns.push({
      title: "Request Number",
      dataIndex: "requestNumber",
      key: "requestNumber",
      ...getColumnSearchProps("requestNumber"),
    });
    columns.push({
      title: "Material",
      dataIndex: "stockTypeCode",
      key: "stockTypeCode",
      ...getColumnSearchProps("stockTypeCode"),
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Measurements",
      key: "measurements",
      render: (text, record) => {
        if (!record.measurements || record.measurements.length === 0) {
          return "N/A";
        }

        return (
          <div>
            {record.measurements.map((measurement, index) => (
              <div key={index}>
                <strong>{measurement.measurementType.name}:</strong>{" "}
                {measurement.measurementValue}
              </div>
            ))}
          </div>
        );
      },
    });
    columns.push({
      title: "Veri. Pallets",
      key: "verifyPallets",
      align: "right",
      render: (text, record) => {
        return record.requestedItemsByPallets.length;
      },
    });
    columns.push({
      title: "Veri. Quantity",
      key: "verifyQuantity",
      align: "right",
      render: (text, record) => {
        return (
          record.requestedItemsByPallets.length &&
          record.requestedItemsByPallets
            .map((item) => item.assignQuantity)
            .reduce((prev, next) => prev + next)
        );
      },
    });
    columns.push({
      title: "Status",
      dataIndex: "lineStage",
      key: "lineStage",
      render: (text) => {
        let color = "#87d068";
        return <Tag color={color}>{text}</Tag>;
      },
    });

    return columns;
  };

  return (
    <div>
      <Table
        bordered
        rowKey="id"
        size="small"
        columns={getColumns()}
        dataSource={props.verifiedLines}
        pagination={false}
        rowSelection={rowSelection}
      />
    </div>
  );
};

export default RequestLineSelection;
